import React, { useEffect, useState } from 'react';
import KitLoader from '../../components/kitsters/KitLoader';
import TableBundle from "./TableBundle"
import {getbundledata, getdata, getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';

const BundleCheck = () => {
  const [loading, setLoading] = useState(true);
  const [bundledata, setbundledata] = useState([]);
  const [bunresolveddata, setbunresolveddata] = useState([]);

  const params = new URLSearchParams(window.location.search);
  const fetchdata = async () => {
    let data = await getbundledata();
    setbundledata(data.data);
    setbunresolveddata(data.bunresolveddata);
    setLoading(false);
  };

  useEffect(() => {
   fetchdata();
  }, []);

  return (

    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}

      <h3 style={{ marginBottom: '16px' }}>BUN-Coposite Items Price Check | Problem Count: {bundledata.length} </h3>
      <TableBundle bundledata={bundledata} bunresolveddata={bunresolveddata} fetchdata={fetchdata}/>

    </div>
  );
};

export default BundleCheck;
